import apiClient from '../api/axios';

export interface CreateBrandingPayload {
  organizationId: string;
  logo: File;
  primaryColor: string;
  secondaryColor: string;
}

// Create Branding
export const createBranding = async (data: CreateBrandingPayload) => {
  const formData = new FormData();
  formData.append('organizationId', data.organizationId);
  formData.append('logo', data.logo);
  formData.append('primaryColor', data.primaryColor);
  formData.append('secondaryColor', data.secondaryColor);

  const response = await apiClient.post('/installations/branding', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
};
